export enum SgConnectEnvironment {
    Homologation = 'homologation',
    Production = 'production',
}